import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import "./profileslider.css";
import Modal from "react-bootstrap/Modal";
import Button from "../../../../Common/components/UI/Button";
import ReactGA from "react-ga4";
export const MenuData = [
  {
    img: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.71 12.7101C16.6904 11.9388 17.406 10.881 17.7572 9.68407C18.1085 8.48709 18.0779 7.21039 17.6698 6.03159C17.2617 4.85279 16.4963 3.83052 15.4801 3.10698C14.4639 2.38344 13.2474 1.99463 12 1.99463C10.7525 1.99463 9.53611 2.38344 8.51993 3.10698C7.50374 3.83052 6.73834 4.85279 6.33021 6.03159C5.92208 7.21039 5.89151 8.48709 6.24276 9.68407C6.59401 10.881 7.3096 11.9388 8.29 12.7101C6.61007 13.3832 5.14428 14.4995 4.04889 15.94C2.95349 17.3806 2.26956 19.0914 2.07 20.8901C2.05555 21.0214 2.06711 21.1543 2.10402 21.2812C2.14093 21.408 2.20246 21.5264 2.28511 21.6294C2.45202 21.8376 2.69478 21.971 2.96 22.0001C3.22521 22.0293 3.49116 21.9519 3.69932 21.785C3.90749 21.6181 4.04082 21.3753 4.07 21.1101C4.28958 19.1553 5.22168 17.3499 6.68822 16.0389C8.15475 14.7279 10.0529 14.0032 12.02 14.0032C13.9871 14.0032 15.8852 14.7279 17.3518 16.0389C18.8183 17.3499 19.7504 19.1553 19.97 21.1101C19.9972 21.3558 20.1144 21.5828 20.2991 21.7471C20.4838 21.9115 20.7228 22.0016 20.97 22.0001H21.08C21.3421 21.97 21.5817 21.8374 21.7466 21.6314C21.9114 21.4253 21.9881 21.1625 21.96 20.9001C21.7595 19.0963 21.0719 17.3811 19.9708 15.9383C18.8698 14.4955 17.3969 13.3796 15.71 12.7101V12.7101ZM12 12.0001C11.2089 12.0001 10.4355 11.7655 9.77772 11.326C9.11992 10.8865 8.60723 10.2618 8.30448 9.53086C8.00173 8.79995 7.92251 7.99569 8.07686 7.21976C8.2312 6.44384 8.61216 5.73111 9.17157 5.1717C9.73098 4.61229 10.4437 4.23132 11.2196 4.07698C11.9956 3.92264 12.7998 4.00186 13.5307 4.30461C14.2616 4.60736 14.8863 5.12005 15.3259 5.77784C15.7654 6.43564 16 7.209 16 8.00012C16 9.06099 15.5786 10.0784 14.8284 10.8286C14.0783 11.5787 13.0609 12.0001 12 12.0001Z"
          fill="#ED1B24"
        />
      </svg>
    ),
    text: "Detalles del perfil",
    link: "/Perfil/MyPerfil",
  },
  {
    img: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 20 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5 10H8C8.26522 10 8.51957 9.89464 8.70711 9.70711C8.89464 9.51957 9 9.26522 9 9C9 8.73478 8.89464 8.48043 8.70711 8.29289C8.51957 8.10536 8.26522 8 8 8H5C4.73478 8 4.48043 8.10536 4.29289 8.29289C4.10536 8.48043 4 8.73478 4 9C4 9.26522 4.10536 9.51957 4.29289 9.70711C4.48043 9.89464 4.73478 10 5 10ZM17 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V12C0 12.7956 0.316071 13.5587 0.87868 14.1213C1.44129 14.6839 2.20435 15 3 15H17C17.7956 15 18.5587 14.6839 19.1213 14.1213C19.6839 13.5587 20 12.7956 20 12V3C20 2.20435 19.6839 1.44129 19.1213 0.87868C18.5587 0.316071 17.7956 0 17 0ZM18 12C18 12.2652 17.8946 12.5196 17.7071 12.7071C17.5196 12.8946 17.2652 13 17 13H3C2.73478 13 2.48043 12.8946 2.29289 12.7071C2.10536 12.5196 2 12.2652 2 12V6H18V12ZM18 4H2V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H17C17.2652 2 17.5196 2.10536 17.7071 2.29289C17.8946 2.48043 18 2.73478 18 3V4Z"
          fill="#ED1B24"
        />
      </svg>
    ),
    text: "Método de pago",
    link: "/Perfil/MyCards",
  },
  {
    img: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M20 5.82245C20.0048 5.75921 20.0048 5.69569 20 5.63245L18 0.632454C17.9219 0.43481 17.7828 0.26719 17.603 0.153909C17.4232 0.0406286 17.212 -0.0124219 17 0.0024534H3C2.79972 0.00225952 2.604 0.0622081 2.43818 0.174534C2.27237 0.28686 2.1441 0.446388 2.07 0.632454L0.0699999 5.63245C0.0651796 5.69569 0.0651796 5.75921 0.0699999 5.82245C0.0367708 5.87812 0.0131096 5.93896 0 6.00245C0.0111306 6.69369 0.201226 7.37025 0.551745 7.96613C0.902263 8.56201 1.40124 9.05688 2 9.40245V19.0025C2 19.2677 2.10536 19.522 2.29289 19.7096C2.48043 19.8971 2.73478 20.0025 3 20.0025H17C17.2652 20.0025 17.5196 19.8971 17.7071 19.7096C17.8946 19.522 18 19.2677 18 19.0025V9.44245C18.6046 9.09343 19.1072 8.59228 19.4581 7.98879C19.809 7.38531 19.9958 6.70051 20 6.00245C20.0094 5.94282 20.0094 5.88209 20 5.82245ZM11 18.0025H9V14.0025H11V18.0025ZM16 18.0025H13V13.0025C13 12.7372 12.8946 12.4829 12.7071 12.2953C12.5196 12.1078 12.2652 12.0025 12 12.0025H8C7.73478 12.0025 7.48043 12.1078 7.29289 12.2953C7.10536 12.4829 7 12.7372 7 13.0025V18.0025H4V10.0025C4.56947 9.99924 5.13169 9.87447 5.64905 9.63648C6.16642 9.39849 6.627 9.05278 7 8.62245C7.37537 9.04808 7.83701 9.38896 8.35425 9.62245C8.87149 9.85595 9.4325 9.9767 10 9.9767C10.5675 9.9767 11.1285 9.85595 11.6458 9.62245C12.163 9.38896 12.6246 9.04808 13 8.62245C13.373 9.05278 13.8336 9.39849 14.3509 9.63648C14.8683 9.87447 15.4305 9.99924 16 10.0025V18.0025ZM16 8.00245C15.4696 8.00245 14.9609 7.79174 14.5858 7.41667C14.2107 7.04159 14 6.53289 14 6.00245C14 5.73724 13.8946 5.48288 13.7071 5.29535C13.5196 5.10781 13.2652 5.00245 13 5.00245C12.7348 5.00245 12.4804 5.10781 12.2929 5.29535C12.1054 5.48288 12 5.73724 12 6.00245C12 6.53289 11.7893 7.04159 11.4142 7.41667C11.0391 7.79174 10.5304 8.00245 10 8.00245C9.46957 8.00245 8.96086 7.79174 8.58579 7.41667C8.21071 7.04159 8 6.53289 8 6.00245C8 5.73724 7.89464 5.48288 7.70711 5.29535C7.51957 5.10781 7.26522 5.00245 7 5.00245C6.73478 5.00245 6.48043 5.10781 6.29289 5.29535C6.10536 5.48288 6 5.73724 6 6.00245C6.00985 6.2651 5.96787 6.52711 5.87646 6.77353C5.78505 7.01995 5.646 7.24595 5.46725 7.43863C5.28849 7.63132 5.07354 7.7869 4.83466 7.89651C4.59578 8.00612 4.33764 8.0676 4.075 8.07745C3.54457 8.09734 3.02796 7.90571 2.63882 7.5447C2.44614 7.36595 2.29055 7.15099 2.18094 6.91211C2.07133 6.67323 2.00985 6.4151 2 6.15245L3.68 2.00245H16.32L18 6.15245C17.9621 6.65647 17.7348 7.12744 17.3637 7.47066C16.9927 7.81388 16.5054 8.00388 16 8.00245Z"
          fill="#ED1B24"
        />
      </svg>
    ),
    text: "Estatus de orden",
    link: "/Perfil/History",
  },
  {
    img: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13.71 6.29C13.617 6.19627 13.5064 6.12188 13.3846 6.07111C13.2627 6.02034 13.132 5.9942 13 5.9942C12.868 5.9942 12.7373 6.02034 12.6154 6.07111C12.4936 6.12188 12.383 6.19627 12.29 6.29L10 8.59L7.71 6.29C7.5217 6.1017 7.2663 5.99591 7 5.99591C6.7337 5.99591 6.4783 6.1017 6.29 6.29C6.1017 6.4783 5.99591 6.7337 5.99591 7C5.99591 7.2663 6.1017 7.5217 6.29 7.71L8.59 10L6.29 12.29C6.19627 12.383 6.12188 12.4936 6.07111 12.6154C6.02034 12.7373 5.9942 12.868 5.9942 13C5.9942 13.132 6.02034 13.2627 6.07111 13.3846C6.12188 13.5064 6.19627 13.617 6.29 13.71C6.38296 13.8037 6.49356 13.8781 6.61542 13.9289C6.73728 13.9797 6.86799 14.0058 7 14.0058C7.13201 14.0058 7.26272 13.9797 7.38458 13.9289C7.50644 13.8781 7.61704 13.8037 7.71 13.71L10 11.41L12.29 13.71C12.383 13.8037 12.4936 13.8781 12.6154 13.9289C12.7373 13.9797 12.868 14.0058 13 14.0058C13.132 14.0058 13.2627 13.9797 13.3846 13.9289C13.5064 13.8781 13.617 13.8037 13.71 13.71C13.8037 13.617 13.8781 13.5064 13.9289 13.3846C13.9797 13.2627 14.0058 13.132 14.0058 13C14.0058 12.868 13.9797 12.7373 13.9289 12.6154C13.8781 12.4936 13.8037 12.383 13.71 12.29L11.41 10L13.71 7.71C13.8037 7.61704 13.8781 7.50644 13.9289 7.38458C13.9797 7.26272 14.0058 7.13201 14.0058 7C14.0058 6.86799 13.9797 6.73728 13.9289 6.61542C13.8781 6.49356 13.8037 6.38296 13.71 6.29V6.29ZM17 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V17C0 17.7956 0.316071 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H17C17.7956 20 18.5587 19.6839 19.1213 19.1213C19.6839 18.5587 20 17.7956 20 17V3C20 2.20435 19.6839 1.44129 19.1213 0.87868C18.5587 0.316071 17.7956 0 17 0ZM18 17C18 17.2652 17.8946 17.5196 17.7071 17.7071C17.5196 17.8946 17.2652 18 17 18H3C2.73478 18 2.48043 17.8946 2.29289 17.7071C2.10536 17.5196 2 17.2652 2 17V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H17C17.2652 2 17.5196 2.10536 17.7071 2.29289C17.8946 2.48043 18 2.73478 18 3V17Z"
          fill="#D40000"
        />
      </svg>
    ),
    text: "Pedido cancelado",
    link: "/Perfil/CanceledOrders",
  },
  {
    img: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10.4998 16.0001C10.4998 15.1717 11.1714 14.5001 11.9998 14.5001C12.8282 14.5001 13.4998 15.1717 13.4998 16.0001C13.4998 16.8285 12.8282 17.5001 11.9998 17.5001C11.1714 17.5001 10.4998 16.8285 10.4998 16.0001Z"
          fill="#ED1B24"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.62147 10.5973L7.30603 7.75828C7.26559 7.3943 7.26559 7.02696 7.30603 6.66298L7.32879 6.45809C7.57028 4.2847 9.27888 2.56504 11.4507 2.30953C11.8155 2.26661 12.1841 2.26661 12.5489 2.30953C14.7207 2.56504 16.4293 4.2847 16.6708 6.45809L16.6936 6.66298C16.734 7.02696 16.734 7.3943 16.6936 7.75828L16.3781 10.5972L17.0647 10.6521C18.1474 10.7385 19.0316 11.5524 19.2071 12.6243C19.5731 14.8599 19.5731 17.1403 19.2071 19.3759C19.0316 20.4478 18.1474 21.2617 17.0647 21.3482L15.5686 21.4676C13.1932 21.6572 10.8065 21.6572 8.4311 21.4676L6.93497 21.3482C5.85224 21.2617 4.96814 20.4478 4.79262 19.3759C4.42655 17.1403 4.42655 14.8599 4.79262 12.6243C4.96814 11.5524 5.85224 10.7385 6.93497 10.6521L7.62147 10.5973ZM11.6259 3.79926C11.8743 3.77004 12.1253 3.77004 12.3737 3.79926C13.8523 3.97322 15.0156 5.14402 15.18 6.62373L15.2027 6.82863C15.2309 7.08252 15.2309 7.33874 15.2027 7.59263L14.8816 10.4831C12.9624 10.3595 11.0372 10.3595 9.11801 10.4831L8.79685 7.59263C8.76864 7.33875 8.76864 7.08252 8.79685 6.82863L8.81962 6.62373C8.98403 5.14402 10.1473 3.97322 11.6259 3.79926ZM15.4492 12.0279C13.1533 11.8446 10.8464 11.8446 8.55047 12.0279L7.05434 12.1473C6.65941 12.1788 6.33693 12.4757 6.27291 12.8667C5.93312 14.9418 5.93312 17.0584 6.27291 19.1335C6.33693 19.5245 6.65941 19.8214 7.05434 19.8529L8.55047 19.9723C10.8464 20.1556 13.1533 20.1556 15.4492 19.9723L16.9454 19.8529C17.3403 19.8214 17.6628 19.5245 17.7268 19.1335C18.0666 17.0584 18.0666 14.9418 17.7268 12.8667C17.6628 12.4757 17.3403 12.1788 16.9454 12.1473L15.4492 12.0279Z"
          fill="#ED1B24"
        />
      </svg>
    ),
    text: "Cambiar contraseña",
    link: "/Perfil/ChnagePassword",
  },
];
const ProfileSidebar = () => {
  const location = useLocation();

  const [LogOutModal, setLogOutModal] = useState(false);
  const [LogoutModelSuccess, setLogoutModelSuccess] = useState(false);

  const Navigate = useNavigate();

  function SuccessLogOutModal(props) {
    return (
      <Modal
        {...props}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        centered>
        <Modal.Body className="white text-center pt-3">
          <p className="pt-2 pb-2 Modal-text">Has cerrado sesión con éxito.</p>
          <div className="p-2"></div>
          <div className="LogOut-btns-parent-div">
            {/* <Button variant="black" onClick={props.onHide}>
            Cancelar
          </Button> */}
            <Button
              variant="red"
              onClick={() => {
                setLogoutModelSuccess(false);
                Navigate("/");
              }}>
              OK
            </Button>
          </div>
          <div className="p-2"></div>
        </Modal.Body>
      </Modal>
    );
  }

  function LogOutModalFunc(props) {
    return (
      <Modal
        {...props}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        centered>
        <Modal.Body className="white text-center pt-3">
          <h4 className="pt-2 pb-2">Cerrar sesión</h4>
          <p className="pt-2 pb-2 Modal-text">
            ¿Está seguro que desea cerrar sesión?
          </p>
          <div className="p-2"></div>
          <div className="LogOut-btns-parent-div">
            <Button variant="black" onClick={props.onHide}>
              Cancelar
            </Button>
            <Button
              variant="red"
              onClick={() => {
                setLogOutModal(false);
                setLogoutModelSuccess(true);
                localStorage.removeItem("user-info");
              }}>
              Cerrar sesión
            </Button>
          </div>
          <div className="p-3"></div>
        </Modal.Body>
      </Modal>
    );
  }

  const sidebardata = (text) => {
    ReactGA.event({
      category: "Profile",
      action: text,
    });
  };
  return (
    <>
      <nav className="w-auto d-flex flex-column gap-2">
        {MenuData.map((item, index) => {
          return (
            <NavLink
              style={{ width: "max-content", textDecoration: "none" }}
              key={index}
              to={item.link}
              className="">
              <div className="w-auto d-flex align-items-center gap-2">
                <div
                  // onClick={sidebardata(item.text)}
                  className={
                    location.pathname == item.link
                      ? "SideBarIconActive SideBarIcon"
                      : "SideBarIcon"
                  }>
                  {item.img}
                </div>
                <span
                  style={{ width: "100%" }}
                  className="SideBarTxt"
                  onClick={sidebardata(item.text)}>
                  {item.text}
                </span>
              </div>
            </NavLink>
          );
        })}
        <div
          className="w-auto d-flex align-items-center gap-2"
          style={{ cursor: "pointer" }}
          onClick={() => setLogOutModal(true)}>
          <div className={"SideBarIcon"}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              className=""
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12.59 13.0001L10.29 15.2901C10.1963 15.3831 10.1219 15.4937 10.0711 15.6155C10.0203 15.7374 9.9942 15.8681 9.9942 16.0001C9.9942 16.1321 10.0203 16.2628 10.0711 16.3847C10.1219 16.5065 10.1963 16.6171 10.29 16.7101C10.383 16.8038 10.4936 16.8782 10.6154 16.929C10.7373 16.9798 10.868 17.0059 11 17.0059C11.132 17.0059 11.2627 16.9798 11.3846 16.929C11.5064 16.8782 11.617 16.8038 11.71 16.7101L15.71 12.7101C15.801 12.615 15.8724 12.5029 15.92 12.3801C16.02 12.1366 16.02 11.8636 15.92 11.6201C15.8724 11.4973 15.801 11.3852 15.71 11.2901L11.71 7.2901C11.6168 7.19686 11.5061 7.1229 11.3842 7.07244C11.2624 7.02198 11.1319 6.99601 11 6.99601C10.8681 6.99601 10.7376 7.02198 10.6158 7.07244C10.4939 7.1229 10.3832 7.19686 10.29 7.2901C10.1968 7.38334 10.1228 7.49403 10.0723 7.61585C10.0219 7.73767 9.99591 7.86824 9.99591 8.0001C9.99591 8.13196 10.0219 8.26253 10.0723 8.38435C10.1228 8.50617 10.1968 8.61686 10.29 8.7101L12.59 11.0001H3C2.73478 11.0001 2.48043 11.1055 2.29289 11.293C2.10536 11.4805 2 11.7349 2 12.0001C2 12.2653 2.10536 12.5197 2.29289 12.7072C2.48043 12.8947 2.73478 13.0001 3 13.0001H12.59ZM12 2.0001C10.1311 1.99176 8.29724 2.50731 6.70647 3.48829C5.11569 4.46927 3.83165 5.87641 3 7.5501C2.88065 7.78879 2.86101 8.06512 2.94541 8.3183C3.0298 8.57147 3.21131 8.78075 3.45 8.9001C3.68869 9.01945 3.96502 9.03909 4.2182 8.95469C4.47137 8.8703 4.68065 8.68879 4.8 8.4501C5.43219 7.17342 6.39383 6.08872 7.58555 5.30809C8.77727 4.52746 10.1558 4.07922 11.5788 4.00969C13.0017 3.94017 14.4174 4.25188 15.6795 4.91261C16.9417 5.57334 18.0045 6.55913 18.7581 7.7681C19.5118 8.97706 19.9289 10.3653 19.9664 11.7895C20.0039 13.2136 19.6605 14.6219 18.9715 15.8689C18.2826 17.1159 17.2731 18.1563 16.0475 18.8825C14.8219 19.6088 13.4246 19.9946 12 20.0001C10.5089 20.0066 9.04615 19.5925 7.77969 18.8053C6.51323 18.0182 5.49435 16.89 4.84 15.5501C4.72065 15.3114 4.51137 15.1299 4.2582 15.0455C4.00502 14.9611 3.72869 14.9808 3.49 15.1001C3.25131 15.2194 3.0698 15.4287 2.98541 15.6819C2.90101 15.9351 2.92065 16.2114 3.04 16.4501C3.83283 18.0456 5.03752 19.4003 6.52947 20.3741C8.02142 21.348 9.74645 21.9055 11.5261 21.9891C13.3058 22.0727 15.0755 21.6793 16.6521 20.8496C18.2288 20.0199 19.5552 18.7841 20.4941 17.2699C21.433 15.7558 21.9503 14.0182 21.9925 12.2371C22.0347 10.456 21.6003 8.69589 20.7342 7.13893C19.8682 5.58197 18.6018 4.28467 17.0663 3.38121C15.5307 2.47774 13.7816 2.00094 12 2.0001Z"
                fill="#ED1B24"
              />
            </svg>
          </div>
          <span style={{ width: "100%" }} className="SideBarTxt">
            Cerrar sesión
          </span>
        </div>
      </nav>
      <LogOutModalFunc
        show={LogOutModal}
        onHide={() => setLogOutModal(false)}
      />
      <SuccessLogOutModal
        show={LogoutModelSuccess}
        onHide={() => setLogoutModelSuccess(false)}
      />
    </>
  );
};

export default ProfileSidebar;
